import { Component, OnInit } from '@angular/core';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@Component({
  selector: 'app-view-details',
  templateUrl: './view-details.component.html',
  styleUrls: ['./view-details.component.css', '../../../../../assets/css/custom-egd.css']
})
export class ViewDetailsComponent implements OnInit {
  slug: string = "";
  constructor(private readonly breadcrumbService: DoctorBreadcrumbService,
              private readonly providerstateService: ProviderStateService
  ) {
    
   }


  async ngOnInit() {
    this.slug = this.providerstateService.getProviderSlug();
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink:['/', this.slug, 'support'] },
      { label: 'View Details' },
      { label: 'Support' }
    ]);
  }

 
}
